import { render, staticRenderFns } from "./GroupConfigure.vue?vue&type=template&id=23f876f5&scoped=true&"
import script from "./GroupConfigure.vue?vue&type=script&lang=ts&"
export * from "./GroupConfigure.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f876f5",
  null
  
)

export default component.exports